import { purchaseEventName } from "./purchaseEventName";
import { trackEvent } from "./trackEvent";

/** Shape of the sanitized subscription JSON returned by myData. */
type SanitizedSubscription =
  | {
      id?: string | null;
      plan?: {
        slug?: string | null;
        name?: string | null;
        value?: number | null;
      } | null;
    }
  | null
  | undefined;

/**
 * Fire the purchase-completed funnel events (subscription_checkout_completed
 * + purchase_<tier>) for a paid subscription, once per subscription. Used by
 * every surface that confirms a payment: the /purchase-complete page and the
 * PIX renewal modal.
 *
 * The value is the plan's BRL list price — coupon-adjusted amounts live in
 * the payment provider, not on the client.
 *
 * Returns true when the events fired, false when skipped (free/unknown plan,
 * missing data, or already tracked for this subscription).
 */
export function trackPurchaseCompleted(
  subscription: SanitizedSubscription,
): boolean {
  const plan = subscription?.plan;
  const transactionId = subscription?.id;
  if (!plan || !transactionId) return false;

  const purchaseEvent = purchaseEventName(plan.slug || plan.name);
  if (!purchaseEvent) return false;

  const guardKey = `ac_purchase_tracked_${transactionId}`;
  if (localStorage.getItem(guardKey)) return false;
  localStorage.setItem(guardKey, "1");

  const params = {
    plan_slug: plan.slug || plan.name || undefined,
    value: plan.value ?? 0,
    currency: "BRL",
    transaction_id: transactionId,
  };
  trackEvent("subscription_checkout_completed", params);
  trackEvent(purchaseEvent, params);
  return true;
}
